import axios from "axios";
import PageHeader from "components/PageHeader";
import useGetAssurance from "hooks/useGetAssurance";
import isValidMobilePhone from "hooks/useValidMobilePhone";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
// import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useAddParentMutation } from "redux_dir/features/parentApi";
import {
  getParentForm,
  // clearParentCredit,
  // getParentForm,
  setNewParentCredit,
  setParentForm,
} from "redux_dir/features/parentSlice";
import { addBearerToken, addUserId } from "redux_dir/features/userSlice";
import { NUMBER_VERIFIER_PATH } from "routes/api.path";
import { API_URL } from "routes/api";
import { toast } from "sonner";
import { Loader } from "tabler-icons-react";
import { trackLoginSuccess } from "utils/tracking";
import mixpanel from "mixpanel-browser";

function ParentProspectPage() {

  const navigation = useNavigate();
  const [searchParams] = useSearchParams();

  // const student = useGetStudent();

  const parentForm = useSelector(getParentForm);
  const dispatch = useDispatch();
  // console.log(parentForm);

  const getAssrence = useGetAssurance();

  const [ADDPARENT, { isLoading }] = useAddParentMutation();
  // const [loginUser, { isLoginLoading }] = useLoginUserMutation();
  const [isVerifyNumberLoading, setIsVerifyNumberLoading] = useState(false);

  const provenance = useGetAssurance();

  useEffect(() => {
    const autoLoginToken = searchParams.get("token");
    if (autoLoginToken) {
      const performAutoLogin = async () => {
        try {
          setIsVerifyNumberLoading(true);
          const res = await axios.post(
            API_URL + "auth/auto-login/",
            { token: autoLoginToken }
          );
          
          if (res?.data?.status === "error") {
            toast.error(res.data.message || "Ce lien a déjà été utilisé ou est invalide.");
            return;
          }

          if (res?.status === 200 && (res?.data?.status === "success" || res?.data?.access_token)) {
            const bearer = res?.data?.access_token;
            if (bearer) {
              try {
                localStorage.setItem("auth_token", bearer);
              } catch {}
              dispatch(addBearerToken(bearer));
            }
            
            const user = res?.data?.user;
            if (user) {
              dispatch(setParentForm({ ...user }));
              dispatch(addUserId(user.id));
              
              trackLoginSuccess(searchParams);
              
              if (user.id) {
                mixpanel.identify(user.id);
                mixpanel.people.set({
                  "$phone": user.phone,
                  "$name": user.fullName || user.phone,
                });
                mixpanel.track("Connexion Automatique Réussie");
              }

              navigation("/parentProspect/select-enfant", { replace: true });
              toast.success(res?.data?.message || "Connexion automatique réussie !");
            }
          }
        } catch (error) {
          console.error("Auto login error:", error);
          const errorMessage = error?.response?.data?.message || "Erreur de connexion automatique ou lien expiré";
          toast.error(errorMessage);
        } finally {
          setIsVerifyNumberLoading(false);
        }
      };
      
      performAutoLogin();
    }
  }, []); // Run once on mount

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm({
    // defaultValues: {
    //   fullName: parentForm?.fullName ?? "",
    //   phone: parentForm?.phone ?? "",
    //   email: parentForm?.email ?? "",
    // },
  });

  /**
   * identification et / ou creation d'un parent
   * @param {*} data
   * @returns
   */
  const onSubmit = async (data) => {
    if (!isValidMobilePhone(data?.phone)) {
      return setError("phone", { message: "Numéro de téléphone invalide !" });
    }

    const formatPhone = data?.phone
      .replace("+221", "")
      .replace(" ", "")
      .split(" ")
      .join("");

    const formatData = {
      ...data,
      phone: formatPhone,
      type: "CONTACT",
      isProspect: true,
      agentCommercialFullName: data?.agentCommercialFullName ?? null,
      utm_source: searchParams.get("utm_source"),
      utm_medium: searchParams.get("utm_medium"),
      utm_campaign: searchParams.get("utm_campaign"),
    };

    // return console.log({ formatData });
    try {
      setIsVerifyNumberLoading(true);
      const resVerifyNumber = await axios.get(
        NUMBER_VERIFIER_PATH + formatPhone + "/",
      );
      setIsVerifyNumberLoading(false);

      // return console.log(resVerifyNumber);
      if (
        resVerifyNumber?.status === 200 &&
        resVerifyNumber?.data?.message === "deja inscrit"
      ) {
        if (resVerifyNumber?.data?.user) {
          // Si le backend renvoie un token JWT dans verify/number, le stocker
          const bearer =
            resVerifyNumber?.data?.access_token || resVerifyNumber?.data?.token;
          if (bearer) {
            try {
              localStorage.setItem("auth_token", bearer);
            } catch {}
            dispatch(addBearerToken(bearer));
          }
          if (!resVerifyNumber?.data?.user?.type) {
            return toast.warning("Vous n'êtes pas autorisé à vous connecter.");
          }
          // return console.log(resVerifyNumber?.data?.user);

          if (
            resVerifyNumber?.data?.user?.provenance === "Senassurance" &&
            getAssrence !== "Senassurance"
          ) {
            // console.log("sens aussurence only");

            toast.error("L'utilisateur n'a pas le droit de se connecter ici");
            return;
          }

          if (
            resVerifyNumber?.data?.user?.provenance === "Genimi" &&
            getAssrence === "Senassurance"
          ) {
            // console.log("sens aussurence only");

            toast.error("L'utilisateur n'a pas le droit de se connecter ici");
            return;
          }

          dispatch(setParentForm({ ...resVerifyNumber?.data?.user }));
          dispatch(addUserId(resVerifyNumber?.data?.user?.id));

          // Rediriger vers l'onboarding uniquement si:
          // - L'onboarding n'est pas complété ET
          // - Le parent n'a pas d'enfants (nouveau parent)
          // Les parents existants avec des enfants ne sont pas concernés
          const user = resVerifyNumber?.data?.user;
          // if (user?.has_completed_onboarding === false && user?.countEnfant === 0) {
          //   navigation("/new-onboarding", { replace: true });
          //   toast.success("Connexion réussie !");
          //   return;
          // }
          trackLoginSuccess(searchParams);

          if (user?.id) {
            mixpanel.identify(user.id);
            mixpanel.people.set({
              "$phone": user.phone || formatPhone,
              "$name": user.fullName || user.phone || formatPhone,
            });
            mixpanel.track("Connexion Réussie");
          }

          navigation("select-enfant", {
            replace: true,
          });
          toast.success("Connexion réussie !");
        } else {
          toast.error("Erreur lors de la vérification");
        }
        return;
      }

      const res = await ADDPARENT(
        provenance === "Senassurance"
          ? { ...formatData, provenance }
          : { ...formatData },
      );

      if (!res?.error) {
        // Stocker le token si le backend le retourne
        const bearer =
          res?.data?.access_token || res?.data?.token || res?.data?.data?.token;
        if (bearer) {
          try {
            localStorage.setItem("auth_token", bearer);
          } catch {}
          dispatch(addBearerToken(bearer));
        }

        dispatch(setParentForm({ ...res?.data?.data }));
        dispatch(addUserId(res?.data?.data.id));
        dispatch(setNewParentCredit({ phone: res?.data?.data?.phone }));

        trackLoginSuccess(searchParams);

        const newUser = res?.data?.data;
        if (newUser?.id) {
          mixpanel.identify(newUser.id);
          mixpanel.people.set({
            "$phone": newUser.phone || formatPhone,
            "$name": newUser.fullName || newUser.phone || formatPhone,
          });
          mixpanel.track("Inscription Réussie");
        }

        // Nouveau parent -> toujours rediriger vers l'onboarding
        navigation("/new-onboarding", {
          replace: true,
        });
        toast.success("Création de compte réussie !");
        return;
      }
    } catch (error) {
      setIsVerifyNumberLoading(false);
      // console.log({ error });

      // Vérifier si l'utilisateur n'existe pas (404 du backend)
      const errorMessage = error?.response?.data?.message || "";
      const errorStatus = error?.response?.data?.status || "";
      const isUserNotFound =
        error?.response?.status === 404 ||
        errorMessage.includes("l'utilisateur n'existe pas") ||
        (errorStatus === "failure" && errorMessage.includes("n'existe pas"));

      if (isUserNotFound) {
        // L'utilisateur n'existe pas, on le crée
        try {
          const res = await ADDPARENT(
            provenance === "Senassurance"
              ? { ...formatData, provenance }
              : { ...formatData },
          );

          if (!res?.error) {
            // Stocker le token si le backend le retourne
            const bearer =
              res?.data?.access_token ||
              res?.data?.token ||
              res?.data?.data?.token;
            if (bearer) {
              try {
                localStorage.setItem("auth_token", bearer);
              } catch {}
              dispatch(addBearerToken(bearer));
            }

            dispatch(setParentForm({ ...res?.data?.data }));
            dispatch(addUserId(res?.data?.data.id));
            dispatch(setNewParentCredit({ phone: res?.data?.data?.phone }));

            trackLoginSuccess(searchParams);

            const createdUser = res?.data?.data;
            if (createdUser?.id) {
              mixpanel.identify(createdUser.id);
              mixpanel.people.set({
                "$phone": createdUser.phone || formatPhone,
                "$name": createdUser.fullName || createdUser.phone || formatPhone,
              });
              mixpanel.track("Inscription Réussie");
            }

            // Nouveau parent -> toujours rediriger vers l'onboarding
            navigation("/parentProspect/select-enfant", {
              replace: true,
            });
            toast.success("Création de compte réussie !");
            return;
          } else {
            setError("root", {
              message:
                res?.error?.data?.message ||
                "Erreur lors de la création du compte",
            });
          }
        } catch (createError) {
          console.error("Erreur création parent:", createError);
          setError("root", { message: "Erreur lors de la création du compte" });
        }
        return;
      }

      setError("root", { message: "Une erreur est survenue" });
    }
  };

  if (parentForm?.phone) {
    // Si le parent n'a pas complété l'onboarding ET qu'il n'a pas d'enfants (nouveau parent)
    // Les parents existants avec des enfants ne sont pas concernés
    // if (!parentForm?.has_completed_onboarding && parentForm?.countEnfant === 0) {
    //   return <Navigate to="/new-onboarding" replace />;
    // }
    return <Navigate to="/parentProspect/select-enfant" replace />;
  }

  return (
    <div
      style={{
        backgroundColor: "#003880",
        color: "#fff",
        height: "100dvh",
        overflowY: "auto",
        paddingTop: 10,
      }}
    >
      <PageHeader title={"Informations du parent"} canShow={false} />
      {/* <RenderData
        data={{}}
        render={() => (
        )}
      /> */}
      <div className="p-4">
        <div className="border-t-[1px] pt-4 border-gray flex flex-col items-center gap-10 mb-6">
          <div className="flex items-center justify-center gap-10 p-2">
            <img src="../../icons/icon1.png" style={{ width: 60 }} alt="logo" />
            {getAssrence === "Senassurance" ? (
              <img
                src="../../icons/senassurance.png"
                style={{ width: 70 }}
                alt="logo"
              />
            ) : null}
          </div>

          <span className="text-sm flex flex-col items-center r w-full ">
            <p>Avant de commencer</p>
            <p>merci de remplir ce formulaire</p>
          </span>
        </div>
        <form
          className="flex flex-col gap-4 mt-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          {errors?.root ? (
            <div className="text-danger text-md mt-1">
              {errors?.root?.message}
            </div>
          ) : null}
          <p className="font-bold">Informations du Parent</p>
          <div className="">
            <div className="border-gray border-2 bg-[#fff] rounded-lg p-2 flex-1 flex flex-col">
              <label className="text-sm text-[rgba(0,0,0,0.6)] font-bold">
                Prénom et nom
              </label>
              <input
                placeholder="écrire ici..."
                className="focus:outline-none text-[#000] p-1 flex-1"
                type="text"
                {...register("fullName", {
                  required: "Nom complet est requis",
                })}
              />
            </div>
            {errors?.fullName ? (
              <div className="text-danger text-xs mt-1">
                {errors?.fullName?.message}
              </div>
            ) : null}
          </div>

          <div className="">
            <div className="border-gray border-2 bg-[#fff] rounded-lg p-2 flex-1 flex flex-col">
              <label className="text-sm text-[rgba(0,0,0,0.6)] font-bold">
                Numéro de téléphone
              </label>
              <input
                placeholder="écrire ici..."
                className="focus:outline-none text-[#000] p-1"
                type="tel"
                {...register("phone", {
                  required: "Numéro de téléphone est requis",
                })}
              />
            </div>
            {errors?.phone ? (
              <div className="text-danger text-xs mt-1">
                {errors?.phone?.message}
              </div>
            ) : null}
          </div>

          {/* Champ "Qui êtes-vous" supprimé - l'info est maintenant collectée dans l'onboarding */}

          {/* <div className="">
            <div className="border-gray border-2 bg-[#fff] rounded-lg p-2 flex-1 flex flex-col">
              <label className="text-sm text-[rgba(0,0,0,0.6)] font-bold">
                Email
              </label>
              <input
                placeholder="écrire ici..."
                className="focus:outline-none text-[#000] p-1"
                type="email"
                {...register("email", {
                  // required: "Adresse Email est requise",
                })}
              />
            </div>
            {errors?.email ? (
              <div className="text-danger text-xs mt-1">
                {errors?.email?.message}
              </div>
            ) : null}
          </div> */}

          {/* <div className="mt-5 w-[100%] bg-white">
            <div>
              <label className="text-gray-500 m-0 p-0 text-xs">Email</label>
              <input
                type="email"
                // value={formData.phone_number}
                // onChange={handleInputChange}
                className="border-gray-300 border w-[100%] rounded-md p-2 mt-1 focus:ring focus:ring-gray-200"
                placeholder="Email"
                {...register("email", {
                  required: true,
                })}
              />
            </div>
          </div> */}
          {/* 
          {getAssrence === "Senassurance" ? (
            <>
              <div className="h-1 w-full bg-[#0003]"></div>

              <div className="">
                <div className="border-gray border-2 bg-[#fff] rounded-lg p-2 flex-1 flex flex-col">
                  <label className="text-sm text-[rgba(0,0,0,0.6)]">
                    Prénom et nom de l'agent commercial
                  </label>
                  <input
                    placeholder="écrire ici..."
                    className="focus:outline-none text-[#000]"
                    type="text"
                    {...register("agentCommercialFullName", {
                      // required: "agentCommercialFullName est requis",
                    })}
                  />
                </div>
                {errors?.agentCommercialFullName ? (
                  <div className="text-danger text-xs mt-1">
                    {errors?.agentCommercialFullName?.message}
                  </div>
                ) : null}
              </div>
            </>
          ) : null} */}

          <div className="my-8">
            <button
              className="text-[#000] bg-white rounded-full flex items-center justify-center gap-4 p-3 w-full"
              type="submit"
              disabled={isLoading || isVerifyNumberLoading}
            >
              {isLoading || isVerifyNumberLoading ? (
                <Loader className="animate-spin" color="#000" />
              ) : null}
              Commencer le diagnostic
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ParentProspectPage;
